module.exports = __webpack_public_path__ + "img/guernsey.18d4b6e.webp";